<svg-icon [svgStyle]="{ 'width.px': width, 'height.px': height }"
    [src]="iconPath"></svg-icon>